import { useState } from 'react';
import { getNewTimeSlot } from '../helpers';
import moment from 'moment';

const useLogic = ({ handleSubmit }) => {
  const [prospectId, setProspectId] = useState('');
  const [dateTimePreset, setDateTimePreset] = useState([getNewTimeSlot?.()]);
  const [filters, setFilters] = useState({});

  const handleChange = ({ key, value, id }) => {
    if (key === 'prospectId') {
      setProspectId(value);
    } else {
      setDateTimePreset(
        dateTimePreset?.map(slot => {
          if (slot?.id === id) {
            return {
              ...slot,
              [key]: value,
            };
          }
          return { ...slot };
        }),
      );
    }
  };

  const handleAddNewSlot = () => {
    const preset = {
      ...getNewTimeSlot?.(),
    };
    setDateTimePreset([...dateTimePreset, preset]);
  };

  const handleRemoveSlot = id => {
    setDateTimePreset(dateTimePreset?.filter(slot => slot?.id !== id));
  };

  const handleFilterChange = ({ key, value }) => {
    setFilters(prevFilters => ({ ...prevFilters, [key]: value }));
  };

  const handleSubmit̨MappingSearch = () => {
    const requestedTimes = dateTimePreset?.map(({ date, time }) =>
      moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').unix(),
    );
    handleSubmit?.({ requestedTimes, prospectId, filters });
  };

  const showAddSlotButton = dateTimePreset.length < 3;
  const enableMappingSearchSubmit =
    prospectId && dateTimePreset?.every(({ date, time }) => date && time);

  return {
    prospectId,
    dateTimePreset,
    handleChange,
    handleAddNewSlot,
    handleRemoveSlot,
    showAddSlotButton,
    enableSubmit: enableMappingSearchSubmit,
    handleSubmit̨MappingSearch,
    filters,
    handleFilterChange,
  };
};

export default useLogic;
